<template>
  <div>
    <v-snackbar
      v-model="errors.items"
      v-show="errors.items.length > 0"
      :color="'error'"
      :multi-line="mode === 'multi-line'"
      :vertical="mode === 'vertical'"
      :timeout="timeout"
      auto-height
      relative
      top
    >
      <v-layout row>
        <v-flex>
          <v-icon x-large class="mt-2 no-select">error</v-icon>
        </v-flex>
        <v-flex>
          <ul>
            <li v-for="error in errors.items" :key="error.id">
              <span>{{ $t(error['msg']) }}</span>
            </li>
          </ul>
        </v-flex>
        <v-flex>
          <v-btn dark flat large class="snackbar-close-btn" @click="resetAllErrors(true)">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-snackbar
      v-model="backendErrors"
      v-show="backendErrors.length > 0"
      :color="'error'"
      :multi-line="mode === 'multi-line'"
      :vertical="mode === 'vertical'"
      :timeout="timeout"
      auto-height
      relative
      top
    >
      <v-layout row>
        <v-flex>
          <v-icon x-large class="mt-2 no-select">error</v-icon>
        </v-flex>
        <v-flex>
          <ul>
            <li v-for="beError in backendErrors" :key="beError">
              <span>{{ $t(beError) }}</span>
            </li>
          </ul>
        </v-flex>
        <v-flex>
          <v-btn dark flat large class="snackbar-close-btn" @click="resetAllErrors()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'errorsNotification',

  data() {
    return {
      mode: '',
      timeout: 0,
      allErrorsList: []
    }
  },

  computed: {
    ...mapGetters({
      backendErrors: 'errors/getErrorsList'
    })
  },

  methods: {
    ...mapActions({
      resetAllErrors: 'errors/resetAllErrors'
    })
  }
}
</script>

<style scoped>
.errors-list {
  padding: 0;
  margin: 0;
  margin-left: 20px;
}
.application--is-rtl .errors-list {
  margin-right: 100px !important;
}

.v-snack__wrapper {
  transition: all;
}
.v-snack__content {
  position: relative;
  z-index: 9999 !important;
}
.snackbar-close-btn {
  position: relative !important;
  color: rgba(0, 0, 0, 0.3) !important;
  padding: 15px !important;
}
.snackbar-close-btn:hover,
.snackbar-close-btn:focus {
  color: rgba(0, 0, 0, 0.5) !important;
}
.application--is-rtl .v-snack__content .v-icon {
  margin-right: 0 !important;
  margin-left: 20px !important;
}
.application--is-rtl .snackbar-close-btn {
  margin-left: 0 !important;
  margin-right: 30px !important;
}
</style>
